import { createSlotRecipe } from './runtime';

const tagsInputConfig = {"name":"tagsInput","slots":["root","label","control","input","clearTrigger","item","itemPreview","itemInput","itemText","itemDeleteTrigger"],"defaultVariants":{"size":"md"},"variantMap":{"size":["md"]}}

export const tagsInput = /* @__PURE__ */ createSlotRecipe(tagsInputConfig)